import { Reducer } from 'redux';

import { ActionTypes } from '../types/action-types';
import { ActionObject, IHBConfig } from '../types/config';

export default ((state = {
  enabled: false,
  mapping: {
  }
}, action: ActionObject): IHBConfig => {
  switch (action.type) {
    case ActionTypes.HB_CONFIG_LOADED:
      return {
        ...action.config,
      };
  }
  return {...state};
}) as Reducer<IHBConfig>;



// WEBPACK FOOTER //
// ./src/sub-projects/hubspot/reducers/config.ts